<template>
  <div
    v-if="!fidelityStore.isFetching"
    class="w-full rounded-md bg-soft-peach-100 self-end p-8 col-span-4 h-fit mb-10"
  >
    <div
      class="flex flex-col md:flex-row gap-8 items-center text-center md:text-left"
    >
      <nuxt-img
        src="images/services/calendar.svg"
        class="w-24 lg:w-40 shrink-0 object-contain"
      />
      <div>
        <h1 class="text-xl lg:text-3xl text-cerise-red-600 font-extrabold mb-4">
          I punti si potranno accumulare fino al
          {{ parseDate(fidelityStore.programDateEnd)?.long ?? "14 Novembre 2026" }}.
        </h1>
        <br />
        <h3 class="text-sm md:text-base">
          Eventuali coupon residui potranno essere utilizzati fino al
          {{ parseDate(fidelityStore.couponRedemptionDateEnd)?.long ?? '30 novembre 2026' }}. Alla scadenza del programma eventuali residui saranno azzerati.
        </h3>
      </div>
    </div>
  </div>
  <div
    v-else
    class="bg-black-haze-50 rounded-md h-32 w-full animate-pulse col-span-4"
  ></div>
</template>

<script setup>
import { useProfile } from "~/store/profile";
import { useFidelityStore } from "~/store/fidelity";
import {
  parseDate,
} from "~/composables/format-date";

const profileStore = useProfile();
await profileStore.getProfile();

const fidelityStore = useFidelityStore();
</script>
